import { Skeleton, cn } from '@wellesley/ui'
import { FC } from 'react'

type BrandSectionSkeletonProps = {
  className?: string
}

export const BrandSectionSkeleton: FC<BrandSectionSkeletonProps> = ({
  className,
}) => {
  return (
    <div
      data-testid="branding"
      className={cn(
        'flex h-full w-[588px] flex-col justify-between bg-white px-xxxl pb-xl pt-xxxl',
        className,
      )}
    >
      <div>
        <div className="relative mb-12">
          <Skeleton className="h-[200px] w-full" />
          <div className="absolute left-1/2 top-full -translate-x-1/2 -translate-y-1/2">
            <Skeleton className="h-16 w-16 rounded-full" />
          </div>
        </div>
        <div className="flex w-full flex-col items-center pt-m">
          <Skeleton className="h-10 w-64" />
          <div className="my-xs flex items-center gap-xxxs">
            <Skeleton className="h-4 w-4 rounded" />
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-1" />
            <Skeleton className="h-4 w-16" />
          </div>
          <div className="mt-m w-full space-y-xxs">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-5/6" />
            <Skeleton className="h-4 w-4/5" />
          </div>
          <div className="mt-xl flex justify-center">
            <Skeleton className="h-10 w-40 rounded-md" />
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-xxxs">
          <Skeleton className="h-4 w-4" />
          <Skeleton className="h-4 w-32" />
        </div>
        <Skeleton className="h-4 w-20" />
      </div>
    </div>
  )
}
